import {Injectable} from '@angular/core';
import {ListItem, ListItemDto} from './model/list-item';
import {List, ListDto} from './model/list';

@Injectable({
  providedIn: 'root'
})
export class ListMapperService {

  constructor() {
  }

  toList(listDto: ListDto, listItemDtos: ListItemDto[]): List {
    return {
      created: listDto.created,
      items: listItemDtos.map(item => this.toListItem(item)),
      name: listDto.name,
    };
  }

  toListItem(itemDto: ListItemDto): ListItem {
    return {
      id: itemDto.id,
      name: itemDto.name,
      shortName: itemDto.shortName,
      collected: itemDto.collected,
      amount: itemDto.amount,
    };
  }

  toListDto(list: List): ListDto {
    return {
      name: list.name,
      created: list.created,
    };
  }

  toListItemDto(listItem: ListItem): ListItemDto {
    return {
      name: listItem.name,
      shortName: listItem.shortName,
      amount: listItem.amount,
      collected: listItem.collected,
    };
  }

}
